var isProcessingStyle = {
  position: 'relative'
};
var isLoadingIndicatorStyle = {
  alignItems: 'center',
  background: 'rgba(255, 255, 255, 0.9)',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  margin: 'auto',
  position: 'absolute',
  width: '100%',
  zIndex: '1'
};
export { isLoadingIndicatorStyle, isProcessingStyle };